import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ApplyCTA from "@/components/shared/ApplyCTA";

const LINKS = [
  { href: "#method", label: "The Method" },
  { href: "#inside", label: "Inside" },
  { href: "#story", label: "Story" },
  { href: "#guarantee", label: "How" },
  { href: "#faq", label: "FAQ" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <header
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-500 ${
        scrolled ? "py-2 surface-glass border-b border-soft" : "py-4 bg-transparent"
      }`}
    >
      <div className="access-container flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" aria-label="Closer Academy — home">
          <span className="w-7 h-7 rounded-full border border-gold flex items-center justify-center font-display text-gold text-[13px]" style={{ fontVariationSettings: '"opsz" 48, "SOFT" 30', fontWeight: 500 }}>C</span>
          <span className="font-mono text-bone text-[11px] tracking-[0.22em] uppercase">Closer Academy</span>
        </Link>
        <nav className="hidden md:flex items-center gap-7 font-mono text-[11px] tracking-[0.2em] uppercase text-dim">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} className="hover:text-bone transition-colors">{l.label}</a>
          ))}
        </nav>
        <ApplyCTA className="!min-h-[42px] md:!min-h-[44px] !px-5 !text-[10.5px]" />
      </div>
    </header>
  );
}
